import { put, takeEvery } from 'redux-saga/effects';
import { push } from 'connected-react-router';

export function* handleRedirection({
  payload,
  meta: { redirectTo },
}) {
  if (redirectTo == null) return;
  const redirectOption = typeof redirectTo === 'function' ? redirectTo.call(this, payload) : redirectTo;
  yield put(
    push(redirectOption),
  );
}

export default function* () {
  yield takeEvery(
    // @ts-ignore
    (action) => action.meta && typeof action.meta.redirectTo !== 'undefined',
    handleRedirection,
  );
}
